// extracted by mini-css-extract-plugin
var _1 = "NewsboardPostFileDeleteConfirmationModal-modulecheckbox__buzg0";
var _2 = "NewsboardPostFileDeleteConfirmationModal-modulecheckboxLabel__lGAnq";
var _3 = "NewsboardPostFileDeleteConfirmationModal-modulecheckboxLabelTitle__nfcdK";
export { _1 as "checkbox", _2 as "checkboxLabel", _3 as "checkboxLabelTitle" }
